/**
 * Capa de alertas de Global Forest Watch (tile raster, solo visualización) que
 * se ofrece en el árbol de capas de monitoreo.
 */
export class GfwTileValueObject {
  constructor(
    public readonly id: string,
    public readonly name: string,
    public readonly dataset: string,
    public readonly opacity: number | null = null,
  ) {}
}